import { createRoute } from '@tanstack/react-router';
import { onboardingParentRoute } from 'pages/shared/Onboarding/onboardingParentRoute';
import { z } from 'zod';

export const onboardingVerifyEmailRoute = createRoute({
  getParentRoute: () => onboardingParentRoute,
  path: '/verify_email',
  validateSearch: z.object({
    email: z.string().optional(),
  }),
}).lazy(() => import('pages/shared/Onboarding/VerifyEmail/VerifyEmailPage').then((d) => d.Route));
